import * as React from "react";
import { Row, Col } from "antd";
import { TourType } from "../../../lib/model/TourType";
import styled from "styled-components";

const StyledButton = styled.button`
  width: 160px;
  height: 43px;
  border: none !important;
  outline: none !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #386de8;
  color: #ffffff;
  cursor: pointer;
  &:hover {
    background-color: #3d79ff;
  }
`;

const TitleLabel = styled.span`
  font-size: 20px;
  font-weight: 300;
  line-height: 1.6;
  color: #061a32;
  display: inline-block;
`;

const Label = styled.span`
  font-size: 11px;
  font-weight: 300;
  color: #061a32;
  display: inline-block;
  margin-top: 14px;
`;

type Props = {
  onSelect: (type: TourType) => void;
};

export class MultiTypeSelect extends React.Component<Props> {
  render() {
    const { onSelect } = this.props;
    return (
      <Row type="flex" justify="center" style={{ marginTop: 200 }}>
        <Col span={24} style={{ textAlign: "center", marginBottom: 30 }}>
          <TitleLabel>
            Bitte wählen Sie den Typ Ihres Multi-Stopp Auftrags aus.
          </TitleLabel>
        </Col>
        <Col span={12} xs={12} sm={12} md={12} lg={12} xl={12} xxl={8}>
          <Row type="flex" justify="space-between">
            <Col span={12} xs={24} sm={12} md={12} style={{ textAlign: "center" }}>
              <StyledButton onClick={() => onSelect(TourType.Distribution)}>
                Verteilertour
              </StyledButton>
              <Label>
                Es sind mehrer Entladestellen und eine
                <br />
                Beladestelle vorgesehen.
              </Label>
            </Col>
            <Col span={12} xs={24} sm={12} md={12} style={{ textAlign: "center" }}>
              <StyledButton
                onClick={() => onSelect(TourType.Collection)}
              >
                Sammeltour
              </StyledButton>
              <Label>
                Es sind mehrer Beladestellen und eine
                <br />
                Entladestelle vorgesehen.
              </Label>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}
